import { useEffect, useState } from "react";
import { Trash2, Phone, Mail } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiError } from "@/lib/api";

export const LeadsPanel = () => {
  const [leads, setLeads] = useState([]);
  const load = () => api.get("/admin/leads").then((r) => setLeads(Array.isArray(r.data) ? r.data : []))
    .catch((e) => toast.error(formatApiError(e.response?.data?.detail)));
  useEffect(() => { load(); }, []);

  const remove = async (l) => {
    if (!window.confirm(`Delete enquiry from ${l.name}?`)) return;
    try { await api.delete(`/admin/leads/${l.id}`); load(); } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
  };

  return (
    <div data-testid="admin-leads">
      <h1 className="font-display text-3xl font-extrabold text-white">Enquiries</h1>
      <p className="mt-1 text-sm text-slate-400" data-testid="admin-leads-count">{leads.length} enquiries from website forms</p>
      <div className="mt-6 space-y-3">
        {leads.map((l) => (
          <div key={l.id} data-testid={`admin-lead-${l.id}`} className="rounded-2xl border border-white/10 bg-[#0D1526] p-5">
            <div className="flex flex-wrap items-start justify-between gap-3">
              <div>
                <p className="font-bold text-white">{l.name} <span className="ml-2 rounded-full bg-amber-400/15 px-2 py-0.5 text-[11px] uppercase text-amber-300">{l.source}</span></p>
                <p className="mt-1 text-xs text-slate-400">{new Date(l.created_at).toLocaleString()}</p>
              </div>
              <div className="flex items-center gap-3 text-sm">
                <a href={`tel:${l.phone}`} className="flex items-center gap-1 text-amber-300"><Phone className="h-4 w-4" />{l.phone}</a>
                {l.email && <a href={`mailto:${l.email}`} className="flex items-center gap-1 text-slate-300"><Mail className="h-4 w-4" />{l.email}</a>}
                <button onClick={() => remove(l)} aria-label="Delete" data-testid={`admin-lead-delete-${l.id}`} className="rounded-lg p-2 text-red-400 hover:bg-red-500/10"><Trash2 className="h-4 w-4" /></button>
              </div>
            </div>
            {Object.keys(l.details || {}).length > 0 && (
              <p className="mt-3 text-sm text-slate-300">{Object.entries(l.details).map(([k, v]) => `${k.replace(/_/g, " ")}: ${v}`).join(" · ")}</p>
            )}
            {l.message && <p className="mt-2 text-sm text-slate-300">“{l.message}”</p>}
          </div>
        ))}
        {leads.length === 0 && <p className="text-sm text-slate-400">No enquiries yet.</p>}
      </div>
    </div>
  );
};
